import { render, staticRenderFns } from "./D110.vue?vue&type=template&id=0f2e0bd7&scoped=true"
import script from "./D110.vue?vue&type=script&lang=js"
export * from "./D110.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=0f2e0bd7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2e0bd7",
  null
  
)

export default component.exports